import styles from '@/styles/ResetPassword.module.scss'
import BaseLayout from '@/layout/BaseLayout/BaseLayout'
import Head from 'next/head'
import React from 'react'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import DefaultInput from '@/components/inputs/DefaultInput/DefaultInput'
import { useTranslation } from 'next-i18next'
import Button from '@/components/buttons/Button/Button'
import Form from '@/components/common/Form/Form'
import { getPageTitle } from '@/utils/helpers'
import { useResetPasswordMutation } from '@/api/resetPassword'
import { useSnackbar } from '@/utils/hooks/useSnackbar'
import { useRouter } from 'next/router'

type Props = {}

const Login = (props: Props) => {
  const { t } = useTranslation(['login', 'common'])
  const [email, setEmail] = React.useState('')
  const [error, setError] = React.useState('')
  const [resetPassword] = useResetPasswordMutation()
  const { showSnackbar } = useSnackbar()
  const router = useRouter()

  const onEmailChange = (value: string) => {
    setEmail(value)
    setError('')
  }

  const onSubmit = () => {
    if (!email) {
      return
    }

    resetPassword({ email })
      .unwrap()
      .then(() => {
        showSnackbar(t('login:resetPasswordSuccess'))
        setEmail('')
        router.push('/login')
      })
      .catch(() => {
        setError(t('login:invalidEmail') || '')
      })
  }

  return (
    <BaseLayout>
      <Head>
        <title>{getPageTitle(t('login:resetPassword'))}</title>
      </Head>
      <main className={styles.resetPasswordForm}>
        <h2>{t('login:resetPassword')}</h2>
        <p>{t('login:resetPasswordInfo')}</p>
        <Form
          onSubmit={onSubmit}
        >
          <DefaultInput
            name="email"
            label={t('login:email')}
            type="email"
            value={email}
            onChange={onEmailChange}
            error={error}
          />
          <Button
            type="submit"
            label={t('login:resetPassword')}
            rounded={true}
          />
        </Form>
      </main>
    </BaseLayout>
  )
}

export default Login

export const getStaticProps: GetStaticProps<Props> = async ({
  locale,
}) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'en', [
      'common',
      'login',
      'footer',
    ])),
  },
})